/**
 * TODO: produces a a console error:
 * Invalid expression: [object Object],[object Object],[object Object],[object Object]
 *
 * Need to replace with pq-product-details-summary
 */

import classNames from "classnames";
import { FC, createElement } from "react";
import { QuestionExpressionModel, RendererFactory } from "survey-core";
import { ReactQuestionFactory } from "survey-react-ui";
import { ExplainerExpression } from "../../types/explainer";

interface SummaryItem {
  title: string;
  value: string;
}

interface PQProductDetailsSummaryExpressionProps {
  question: QuestionExpressionModel;
}

const PQProductDetailsSummaryExpression: FC<
  PQProductDetailsSummaryExpressionProps
> = ({ question }) => {
  const summaryItems = question.expression as unknown as SummaryItem[];
  /**
   * Parses the summary items string back into an object
   * @returns SummaryItem[]
   */
  const getSummaryItems = (items: string | SummaryItem[]) => {
    try {
      if (typeof items === "string") {
        return JSON.parse(items);
      }
      return items as ExplainerExpression;
    } catch (event: any) {
      console.error("Failed to parse explainer expression:", event);
      return [];
    }
  };
  const summaryItemsParsed: SummaryItem[] = getSummaryItems(summaryItems);

  if (
    summaryItemsParsed === null ||
    summaryItemsParsed === undefined ||
    summaryItemsParsed.length === 0
  ) {
    return <></>;
  }

  return (
    <div className="flex flex-col p-2.5 md:p-5 divide-indigo-100 whitespace-normal rounded-lg shadow-sm md:flex-row md:flex-wrap md:gap-y-5 md:divide-x bg-indigo-25 gap-1.5">
      {summaryItemsParsed.map((item, index) => (
        /**
         * `md:min-w-0` is half of what keeps the row inside the box: a flex
         * item defaults to `min-width: auto`, so it refuses to shrink past its
         * longest word, and once a summary carries enough columns — the CTM
         * action header carries seven — those minimums add up past the
         * container and the extra columns render outside the rounded
         * background. `md:flex-wrap` on the container is the other half; on
         * its own, shrinking seven columns into a ~420px panel leaves each one
         * a word wide and the panel three times taller than wrapping does.
         */
        <div
          key={`${item.title}-${index}`}
          className={classNames(
            "md:px-5 md:block md:min-w-0 flex items-center justify-between gap-5",
            {
              "md:pl-0 md:pr-5": index === 0,
              "md:pl-5 md:pr-0": index === summaryItemsParsed.length - 1,
            }
          )}
        >
          <div className="text-xxs md:text-xs leading-[14px] md:leading-[18px] font-semibold text-indigo-600 break-words">
            {item.title}
          </div>
          <div className="md:mt-2.5 text-xs md:text-sm leading-[18px] md:leading-6 font-regular text-indigo-800 break-words">
            {item.value}
          </div>
        </div>
      ))}
    </div>
  );
};

ReactQuestionFactory.Instance.registerQuestion(
  "sv-pq-product-details-summary-expression",
  function (props: any) {
    return createElement(PQProductDetailsSummaryExpression, props);
  }
);

RendererFactory.Instance.registerRenderer(
  "expression",
  "pq-product-details-summary-expression",
  "sv-pq-product-details-summary-expression"
);
